<template>
  <div class="skel-list" :class="`skel-list--${variant}`">
    <template v-if="variant === 'card'">
      <SkeletonCard v-for="i in count" :key="i" />
    </template>
    <template v-else>
      <SkeletonRow v-for="i in count" :key="i" :columns="columns" />
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import SkeletonCard from './SkeletonCard.vue'
import SkeletonRow from './SkeletonRow.vue'

export default defineComponent({
  name: 'SkeletonList',
  components: { SkeletonCard, SkeletonRow },
  props: {
    variant: { type: String as PropType<'card' | 'row'>, default: 'row' },
    count: { type: Number, default: 4 },
    columns: { type: Array as PropType<number[]>, default: () => [25, 45, 15] }
  }
})
</script>

<style scoped lang="scss">
.skel-list--card {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
}

.skel-list--row {
  border: 1px solid rgba(31, 30, 26, 0.1);
  border-radius: 10px;
  overflow: hidden;
  background: var(--card, #fff);
}
</style>
